import React, { useState } from 'react';

import Tourists from 'src/components/Tourists';

import ClientDataBanner from 'src/routes/Checkout/components/ClientDataBanner';
import { PACKAGE_HOME_PATH, PAY_PATH } from '../../../../store/constants';

import RedirectToPage from '../../../../components/RedirectToPage';
import { Container } from '../../../../routes/styles';

import type { PropsFromRedux } from '.';

export const TouristsRoute = (props: PropsFromRedux): JSX.Element => {
  const {
    redirectToHome,
    redirectToPayment,
    isMobile,
    isLoggedIn,
    isPhoneConfimed,
    clientEmal,
  } = props;

  // При бесшовной авторизации нам нужно ввести почту и нажать подтвердить, чтобы можно было вводить данные туристов
  const [isMailConfirmOpened, setIsMailConfirmOpened] = useState(false);

  if (redirectToHome) {
    return <RedirectToPage path={PACKAGE_HOME_PATH} />;
  }

  if (redirectToPayment) {
    return <RedirectToPage path={PAY_PATH} />;
  }

  return (
    <>
      <Container $isMobile={isMobile}>
        <ClientDataBanner
          isHotelOnly={false}
          setIsMailConfirmOpened={setIsMailConfirmOpened}
        />
      </Container>

      <Container
        $isMobile={isMobile}
        $isDisabled={
          !isLoggedIn || !isPhoneConfimed || !clientEmal || isMailConfirmOpened
        }
      >
        <Tourists />
      </Container>
    </>
  );
};
